import {computed} from "vue";

function ordinal(n) {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;

  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

export function useFullMeetingTitle(selectedYear) {
  const meetingNumber = computed(() => {
    if (!selectedYear?.value) return null;
    const firstYear = 2010;
    const skippedYear = 2020;
    let count = selectedYear.value - firstYear + 1;
    if (selectedYear.value >= skippedYear) count -= 1;
    return count;
  });

  const title = computed(() => {
    if (!meetingNumber.value) return "";
    return `${ordinal(meetingNumber.value)} international meeting on Visualizing Biological Data`;
  });

  return title;
}
